import { Color, PaletteOptions } from '@mui/material/styles';

const grey: Partial<Color> = {
  50: '#FAFAFA',
  100: '#eeeeee',
  200: '#d5d5d5',
  300: '#c1c1c1',
  400: '#a0a0a0',
  500: '#7f7f7f',
  600: '#6b6b6b',
  700: '#4f4f4f',
  800: '#434343',
  900: '#2F2F2F',
  A100: '#707070',
  A200: '#cccccc',
  A400: '#b0b0b0',
  A700: '#000000',
};

const primary = {
  light: '#1ABC9C',
  main: '#17A589',
  dark: '#137976',
  contrastText: '#FFFFFF',
};

const secondary = {
  light: '#3E5871',
  main: '#2C3E50',
  dark: '#1F2D3D',
  contrastText: '#FFFFFF',
};

const info = {
  light: '#D8E25E',
  main: '#BDCD07',
  dark: '#9AA206',
  contrastText: '#000000',
};

const energeticPalette: PaletteOptions = {
  mode: 'light',
  action: {
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  common: { black: '#000', white: '#fff' },
  primary,
  secondary,
  info,
  grey,
  divider: '#D1D1D1',
  text: {
    primary: '#2F2F2F',
    secondary: '#475569',
    disabled: '#a0a0a0',
  },
  background: { paper: '#FAFAFA', default: '#FFFFFF' },
};

export default energeticPalette;
